import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from '@themesberg/react-bootstrap';
import { useNotificationApi } from './context';
import { ErrorNotice, Field } from './ui';

export default function TestRecipients({ disabled, onSelect, mode = 'test' }) {
  const { findRecipients } = useNotificationApi();
  const [phone, setPhone] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const request = useRef(0);
  useEffect(() => {
    setPhone(''); setResult(null); setError(null); setBusy(false);
    return () => { request.current += 1; };
  }, [findRecipients]);
  const search = async () => {
    const sequence = ++request.current;
    setBusy(true); setResult(null); setError(null);
    try { const rows = await findRecipients(phone); if (request.current === sequence) setResult(rows); }
    catch (failure) { if (request.current === sequence) setError(failure); }
    finally { if (request.current === sequence) setBusy(false); }
  };
  return <div className="border rounded p-3 mb-3">
    <Field label={mode === 'test' ? 'Tìm tài khoản nhận thử' : 'Tìm khách hàng bằng số điện thoại'} hint={mode === 'reference' ? 'Chọn khách để tìm vé/đơn. Chưa thay đổi người nhận chiến dịch.' : 'Tìm số điện thoại, đối chiếu tài khoản rồi bấm chọn.'}>
      <div className="d-flex flex-wrap gap-2"><Form.Control aria-label={mode === 'reference' ? 'Số điện thoại khách cần gắn Ref' : 'Số điện thoại khách thử'} type="tel" maxLength={24} style={{ maxWidth: 320 }} value={phone} disabled={disabled}
        onChange={event => { request.current += 1; setPhone(event.target.value); setResult(null); setError(null); setBusy(false); }} />
        <Button variant="outline-primary" disabled={disabled || busy || !phone.trim()} onClick={search}>{busy ? 'Đang tìm…' : 'Tìm tài khoản'}</Button></div>
    </Field>
    <ErrorNotice error={error} />
    {result && !result.length && <p role="status" className="small mb-0">Không tìm thấy tài khoản có số điện thoại chính xác này.</p>}
    {result?.map(row => <div key={row.id} className="border-top py-2">
      <strong>{row.name}</strong><span className="ms-2">{row.phone}</span>
      <div className="small text-muted text-break">ID: {row.id}</div>
      <Button size="sm" className="mt-2" variant="outline-primary" disabled={disabled || !row.active} onClick={() => onSelect(row.id, row)}>{mode === 'test' ? 'Chọn nhận thử' : mode === 'reference' ? 'Chọn khách để tìm Ref' : 'Thêm vào đối tượng'}</Button>
      {!row.active && <span className="small ms-2">Tài khoản chưa hoạt động, không chọn nhận thử.</span>}
    </div>)}
  </div>;
}
